import { render, staticRenderFns } from "./TotalUploadedProducts.vue?vue&type=template&id=0bbb9a0e&scoped=true&"
import script from "./TotalUploadedProducts.vue?vue&type=script&lang=js&"
export * from "./TotalUploadedProducts.vue?vue&type=script&lang=js&"
import style0 from "./TotalUploadedProducts.vue?vue&type=style&index=0&id=0bbb9a0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb9a0e",
  null
  
)

export default component.exports